import { generateUsername, type Rng } from './generator.ts';
import type { Pool } from './pools.ts';

export type UsernameChecker = (candidate: string) => Promise<boolean>;

const MAX_CANDIDATES = 3;

/**
 * Spec "Collision handling": try up to three clean candidates against the
 * server; if all three are taken, keep the third and append `.NN` (10–99).
 * A failing check returns the current candidate unchecked — save-time
 * validation is the backstop.
 */
export async function suggestAvailableUsername(pool: Pool, check: UsernameChecker, rng: Rng = Math.random): Promise<string> {
  let candidate = generateUsername(pool, rng);
  for (let attempt = 1; attempt <= MAX_CANDIDATES; attempt++) {
    let available: boolean;
    try {
      available = await check(candidate);
    } catch {
      return candidate;
    }
    if (available) return candidate;
    if (attempt < MAX_CANDIDATES) candidate = generateUsername(pool, rng);
  }
  const suffix = 10 + Math.floor(rng() * 90);
  return `${candidate}.${suffix}`;
}
